// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"532":"a9f5275f6ab6756e","630":"e51f79e22cb68981"}[chunkId] + ".css";
};